import Vue from 'vue'
import {
  Button,
  Field,
  Icon,
  Notify,
  Toast,
  Divider,
  Grid, GridItem,
  Cell, CellGroup,
  Slider,
  Col, Row,
  NavBar,
  Form,
  Image as VanImage,
  Tabbar, TabbarItem,
  Loading,
  List,
  Search,
  Popup,
  ActionSheet,
  Tab, Tabs,
  Skeleton,
  Picker,
  Overlay,
  Lazyload,
  Swipe, SwipeItem,
  Area,
  Rate,
  ImagePreview,
  Stepper,
  Switch,
  RadioGroup, Radio,
  Checkbox, CheckboxGroup
} from 'vant'

Vue
  .use(Button)
  .use(Field)
  .use(Icon)
  .use(Notify)
  .use(Toast)
  .use(Divider)
  .use(Grid).use(GridItem)
  .use(CellGroup).use(Cell)
  .use(Slider)
  .use(Col).use(Row)
  .use(NavBar)
  .use(Form)
  .use(VanImage)
  .use(Tabbar).use(TabbarItem)
  .use(Loading)
  .use(List)
  .use(Search)
  .use(Popup)
  .use(ActionSheet)
  .use(Tab).use(Tabs)
  .use(Skeleton)
  .use(Picker)
  .use(Overlay)
  .use(Lazyload, {
    lazyComponent: true
  })
  .use(Swipe).use(SwipeItem)
  .use(Area)
  .use(Rate)
  .use(Stepper)
  .use(Switch)
  .use(Radio).use(RadioGroup)
  .use(Checkbox).use(CheckboxGroup)

  Vue.prototype.$ImagePreview = ImagePreview
